(function($) {
	$(function () {

        let copiedTimeout = null

        $('.share-buttons__item--copy-link').on('click', function() {
            window.navigator.clipboard.writeText($(this).data('share-url'))
            $('.share-buttons__copied').stop().fadeIn()
            if (copiedTimeout) clearTimeout(copiedTimeout)
            copiedTimeout = setTimeout(() => {
                $('.share-buttons__copied').stop().fadeOut()
            }, 3000)
        })
        
    })
})(window.jQuery)
